var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.tooltip ? _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "max-width": "320"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-chip', _vm._g(_vm._b({}, 'v-chip', _vm.chipAttrs(attrs), false), on), [_vm._v(" " + _vm._s(_vm.statusText) + " ")])];
      }
    }], null, false, 4239067112)
  }, [_c('span', [_vm._v(_vm._s(_vm.tooltip))])]) : _c('v-chip', _vm._b({}, 'v-chip', _vm.chipAttrs(), false), [_vm._v(" " + _vm._s(_vm.statusText) + " ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }